export const coupons = {
  webHeading: 'You have unlocked personalised coupons',
  appHeading: 'Your coupons',
  webSubHeading: 'Don’t let your coupons expire. Save them on the ACKO app for your next purchase.',
  appSubHeading: 'Explore your coupons and redeem them to get the best deals on your ACKO purchases',
  mwebButtonText: 'Redeem coupons on the app',
  desktopButtonText: 'Redeem coupons on the app',
  backgroundImage: 'https://acko-cms.ackoassets.com/Subtract_1810cba1ad.png',
  coupons: [
    {
      meta: {
        product_image: 'https://acko-cms.ackoassets.com/Health_Insurance_36c22c79b9.png',
        product_name: 'Health Insurance',
        app_link: 'https://www.acko.com/gi/p/health/segmentV2',
        tags: ['health'],
      },
      title: 'Flat 10% off on the app',
      coupon_code: 'ACKO10HEALTH',
      description: 'Get 10% off on your health insurance premium',
    },
  ],
}

export const challanAppRedirectDesktop = {
  modalData: {
    name: 'challan_app_redirect_modal',
    heading: 'Your challan info is now\navailable on the ACKO app',
    subHeading: 'Get access to exclusive app features',
    cards: [
      {
        logoUrl: 'https://acko-cms.ackoassets.com/wallet_2_f3d69a8d74.webp',
        text: 'Pay challans in one tap',
      },
      {
        logoUrl: 'https://acko-cms.ackoassets.com/Verify_2_cc47c74ecf.webp',
        text: 'Get rewards for driving safe',
      },
      {
        logoUrl: 'https://acko-cms.ackoassets.com/refresh_2_2_560a8db8c5.webp',
        text: 'View all past challans ',
      },
    ],
    carImageSrc: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/modal_car_image_f4f780073d.webp',
    qrHeading: 'Download the app',
    qrSubHeading: 'For iOS and Android',
    qrImageSrc: 'https://acko-cms.ackoassets.com/Ackodrive_Service_center_QR_code_68a8be7619.svg',
    hasVideo: false,
    mediaSrc: 'https://acko-cms.ackoassets.com/Challans_detail_page_a349498147.webp',
    bgBlurImageUrl: 'https://acko-cms.ackoassets.com/Ackodrive_modal_image_bottom_layer_86d4ac10f1.webp',
    bgHandImageUrl: 'https://acko-cms.ackoassets.com/Ackodrive_modal_middle_layer_image_102d7d6dd9.webp',
  },
}
